import { jsonFetch } from './../utils/fetch';
import { urls } from './../config';

const getMathTest = () => jsonFetch(urls.mathTest);
const nextStep = data => jsonFetch(`${urls.mathTest}`, data, { method: 'POST' });

export default {
  getMathTest,
  nextStep,
};



// WEBPACK FOOTER //
// ./src/api/mathTest.js